import { TextField } from "@goodgamestudios/createjs-utilities";
import { TextFieldAutoSize } from "@goodgamestudios/createjs-utilities";
import { TextFieldHelper } from "@goodgamestudios/core";

export class Poker2TextFieldHelper {
    /**
     * Ändert die Schriftgröße des Textfeldes bis der Text in der angegbenen Maximalhöhe hineinpasst
     */
    public static changeTextFromatSizeByMaxHeight(size: any, textField: TextField, text: string): void {
        var maxHeight: number = textField.height;
        textField.multiline = true;
        textField.wordWrap = true;
        textField.text = text;
        textField.autoSize = TextFieldAutoSize.LEFT;

        while (textField.textHeight > maxHeight && textField.getTextFormat().size > 6) {
            TextFieldHelper.shrinkText(textField);
        }
    }
}
